interface GoiLogoProps {
  color?: string;
  size?: number;
  onClick?: () => void;
}

function GoiLogo({ color = "var(--black)", size = 24, onClick }: GoiLogoProps) {
  return (
    <>
      <svg
        width={size}
        height={size}
        onClick={onClick}
        style={onClick && { cursor: "pointer" }}
        viewBox="0 0 30 30"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0_13059_4318)">
          <path
            d="M18.0677 9.79603H15.1678V12.6448H18.0677H20.968V4.0988V1.80387V1.25H6.46729V4.0988H18.0677V9.79603Z"
            fill={color}
          />
          <path
            d="M17.8757 14.5966C14.3402 14.5966 11.4736 17.4118 11.4736 20.8849C11.4736 24.358 14.3398 27.1733 17.8757 27.1733C21.4115 27.1733 24.2777 24.358 24.2777 20.8849C24.2777 17.4118 21.4115 14.5966 17.8757 14.5966V14.5966ZM17.8757 24.3403C15.9329 24.3403 14.3578 22.7932 14.3578 20.8849C14.3578 18.9767 15.9329 17.4295 17.8757 17.4295C19.8184 17.4295 21.3935 18.9767 21.3935 20.8849C21.3935 22.7932 19.8184 24.3403 17.8757 24.3403V24.3403Z"
            fill={color}
          />
          <path
            d="M26.5284 9.79591H23.8911V12.6447H26.0857C26.318 12.6447 26.5062 12.8296 26.5062 13.0578V28.7499H29.4065V12.6225C29.4065 12.2938 29.2735 11.9786 29.037 11.7459L27.4208 10.1585C27.1843 9.92619 26.8631 9.79553 26.5284 9.79553V9.79591Z"
            fill={color}
          />
          <path
            d="M12.2778 12.6634V6.94702H9.37747V12.2282C9.37747 12.4564 9.18925 12.6412 8.95695 12.6412H0.65625V15.49H9.40008C9.73473 15.49 10.0556 15.3594 10.2925 15.1271L11.9086 13.5396C12.1451 13.3073 12.2781 12.9918 12.2781 12.6631L12.2778 12.6634Z"
            fill={color}
          />
        </g>
        <defs>
          <clipPath id="clip0_13059_4318">
            <rect
              width="28.75"
              height="27.5"
              transform="translate(0.65625 1.25015)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}

export { GoiLogo };
